/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var _to_consumable_array = require("@swc/helpers/_/_to_consumable_array");
var util = require("util");
var deprecateContext = util.deprecate(()=>{}, "Hook.context is deprecated and will be removed");
function CALL_DELEGATE() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    this.call = this._createCall("sync");
    return this.call.apply(this, _to_consumable_array._(args));
}
function CALL_ASYNC_DELEGATE() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    this.callAsync = this._createCall("async");
    return this.callAsync.apply(this, _to_consumable_array._(args));
}
function PROMISE_DELEGATE() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    this.promise = this._createCall("promise");
    return this.promise.apply(this, _to_consumable_array._(args));
}
var Hook = /*#__PURE__*/ function() {
    function Hook() {
        var args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
        _class_call_check._(this, Hook);
        this._args = args;
        this.name = name;
        this.taps = [];
        this.interceptors = [];
        this._call = CALL_DELEGATE;
        this.call = CALL_DELEGATE;
        this._callAsync = CALL_ASYNC_DELEGATE;
        this.callAsync = CALL_ASYNC_DELEGATE;
        this._promise = PROMISE_DELEGATE;
        this.promise = PROMISE_DELEGATE;
        this._x = undefined;
        // eslint-disable-next-line no-self-assign
        this.compile = this.compile;
        // eslint-disable-next-line no-self-assign
        this.tap = this.tap;
        // eslint-disable-next-line no-self-assign
        this.tapAsync = this.tapAsync;
        // eslint-disable-next-line no-self-assign
        this.tapPromise = this.tapPromise;
    }
    _create_class._(Hook, [
        {
            key: "compile",
            value: function compile(_options) {
                throw new Error("Abstract: should be overridden");
            }
        },
        {
            key: "_createCall",
            value: function _createCall(type) {
                return this.compile({
                    taps: this.taps,
                    interceptors: this.interceptors,
                    args: this._args,
                    type
                });
            }
        },
        {
            key: "_tap",
            value: function _tap(type, options, fn) {
                if (typeof options === "string") {
                    // Fast path: a string options ("name") is by far the most common
                    // case. Build the final descriptor in a single allocation instead
                    // of creating `{ name }` and then `Object.assign`ing it.
                    var name = options.trim();
                    if (name === "") {
                        throw new Error("Missing name for tap");
                    }
                    options = {
                        type,
                        fn,
                        name
                    };
                } else {
                    if (typeof options !== "object" || options === null) {
                        throw new Error("Invalid tap options");
                    }
                    var name1 = options.name;
                    if (typeof name1 === "string") {
                        name1 = name1.trim();
                    }
                    if (typeof name1 !== "string" || name1 === "") {
                        throw new Error("Missing name for tap");
                    }
                    if (typeof options.context !== "undefined") {
                        deprecateContext();
                    }
                    // Fast path: only `name` is set. Build the descriptor as a literal
                    // so `_insert` and downstream consumers see the same hidden class
                    // as the string-options path, avoiding a polymorphic call site.
                    // Scan with `for...in` (cheaper than allocating `Object.keys`)
                    // to verify no other user-provided properties exist - e.g.
                    // webpack's `additionalAssets` - otherwise they'd be dropped.
                    var onlyName = true;
                    for(var key in options){
                        if (key !== "name") {
                            onlyName = false;
                            break;
                        }
                    }
                    if (onlyName) {
                        options = {
                            type,
                            fn,
                            name: name1
                        };
                    } else {
                        options.name = name1;
                        // Preserve previous precedence: user-provided keys win over the internal `type`/`fn`.
                        options = Object.assign({
                            type,
                            fn
                        }, options);
                    }
                }
                options = this._runRegisterInterceptors(options);
                this._insert(options);
            }
        },
        {
            key: "tap",
            value: function tap(options, fn) {
                this._tap("sync", options, fn);
            }
        },
        {
            key: "tapAsync",
            value: function tapAsync(options, fn) {
                this._tap("async", options, fn);
            }
        },
        {
            key: "tapPromise",
            value: function tapPromise(options, fn) {
                this._tap("promise", options, fn);
            }
        },
        {
            key: "_runRegisterInterceptors",
            value: function _runRegisterInterceptors(options) {
                var interceptors = this.interceptors;
                var length = interceptors.length;
                // Common case: no interceptors.
                if (length === 0) return options;
                for(var i = 0; i < length; i++){
                    var interceptor = interceptors[i];
                    if (interceptor.register) {
                        var newOptions = interceptor.register(options);
                        if (newOptions !== undefined) {
                            options = newOptions;
                        }
                    }
                }
                return options;
            }
        },
        {
            key: "withOptions",
            value: function withOptions(options) {
                var mergeOptions = (opt)=>Object.assign({}, options, typeof opt === "string" ? {
                        name: opt
                    } : opt);
                return {
                    name: this.name,
                    tap: (opt, fn)=>this.tap(mergeOptions(opt), fn),
                    tapAsync: (opt, fn)=>this.tapAsync(mergeOptions(opt), fn),
                    tapPromise: (opt, fn)=>this.tapPromise(mergeOptions(opt), fn),
                    intercept: (interceptor)=>this.intercept(interceptor),
                    isUsed: ()=>this.isUsed(),
                    withOptions: (opt)=>this.withOptions(mergeOptions(opt))
                };
            }
        },
        {
            key: "isUsed",
            value: function isUsed() {
                return this.taps.length > 0 || this.interceptors.length > 0;
            }
        },
        {
            key: "intercept",
            value: function intercept(interceptor) {
                this._resetCompilation();
                this.interceptors.push(Object.assign({}, interceptor));
                if (interceptor.register) {
                    for(var i = 0; i < this.taps.length; i++){
                        this.taps[i] = interceptor.register(this.taps[i]);
                    }
                }
            }
        },
        {
            key: "_resetCompilation",
            value: function _resetCompilation() {
                this.call = this._call;
                this.callAsync = this._callAsync;
                this.promise = this._promise;
            }
        },
        {
            key: "_insert",
            value: function _insert(item) {
                this._resetCompilation();
                var taps = this.taps;
                var stage = typeof item.stage === "number" ? item.stage : 0;
                // Fast path: the overwhelmingly common `hook.tap("name", fn)` case
                // has no `before` and default stage 0. If the list is empty or the
                // last tap's stage is <= the new item's stage the item belongs at
                // the end - append in O(1), skipping the Set allocation and the
                // shift loop.
                if (!(typeof item.before === "string" || Array.isArray(item.before))) {
                    var n = taps.length;
                    if (n === 0 || (taps[n - 1].stage || 0) <= stage) {
                        taps[n] = item;
                        return;
                    }
                }
                var before;
                if (typeof item.before === "string") {
                    before = new Set([
                        item.before
                    ]);
                } else if (Array.isArray(item.before)) {
                    before = new Set(item.before);
                }
                var i = taps.length;
                while(i > 0){
                    i--;
                    var tap = taps[i];
                    taps[i + 1] = tap;
                    var xStage = tap.stage || 0;
                    if (before) {
                        if (before.has(tap.name)) {
                            before.delete(tap.name);
                            continue;
                        }
                        if (before.size > 0) {
                            continue;
                        }
                    }
                    if (xStage > stage) {
                        continue;
                    }
                    i++;
                    break;
                }
                taps[i] = item;
            }
        }
    ]);
    return Hook;
}();
Object.setPrototypeOf(Hook.prototype, null);
module.exports = Hook;
